import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { AlertFactory } from '../../factories/AlertFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class Alert extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new AlertFactory
  }

  elementIds() {
    return ['id', 'iconContainerId', 'iconId']
  }

  elementClasses() {
    return ['classes', 'iconContainerClasses']
  }

  elementContents() {
    return ['text', 'hasTitle', 'titleText', 'hasIcon', 'class', 'icon', 'isClosable']
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
      {id: 'iconContainerId', element: 'id', styles: 'iconContainerStyles', selector: '#', variation: null},
      {id: 'iconId', element: 'id', styles: 'iconStyles', selector: '#', variation: null},
    ]
  }

  info() {
    return {
      name: 'Alert',
      icon: 'fa-exclamation-circle',
      variations: this.variationsInfo()
    }
  }
}